module.exports = __webpack_public_path__ + "img/Marquise.f5ff8510.jpg";